<template>
  <h4>Major Sponsor</h4>
  <div>
    <a href="http://www.embo.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embo.png"
        alt="EMBO"
        title="EMBO" />
      <img v-else src="./img/embo-darkMode.png" alt="EMBO" title="EMBO" />
    </a>
  </div>
  <h4>Event Sponsors</h4>
  <div>
    <a href="http://www.h-its.org/en/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/HITS.png"
        alt="Heidelberg Institute for Theoretical Studies"
        title="Heidelberg Institute for Theoretical Studies" />
      <img
        v-else
        src="./img/HITS-darkMode.png"
        alt="Heidelberg Institute for Theoretical Studies"
        title="Heidelberg Institute for Theoretical Studies" />
    </a>
    <a href="http://www.nvidia.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/nvidia.svg" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/NVIDIA-darkMode.svg" alt="NVIDIA" title="NVIDIA" />
    </a>
    <a href="http://www.fourmentinguilbert.org/?set_language=en" rel="nofollow">
      <img
        src="./img/FGFondation.png"
        alt="Fondation Fourmentin-Guilbert"
        title="Fondation Fourmentin-Guilbert" />
    </a>
    <a href="http://www.autodesk.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
      <img
        v-else
        src="./img/Autodesk-darkMode.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
    </a>
    <a href="http://www.nature.com/nmeth/index.html" rel="nofollow">
      <img src="./img/Nature_Methods.png" alt="Nature Methods" title="Nature Methods" />
    </a>
  </div>
  <h4>Silver Sponsors</h4>
  <div>
    <img src="./img/FEI.png" alt="FEI" title="FEI" />
  </div>
  <h4>Bronze Sponsors</h4>
  <div>
    <img src="./img/DEMCON.png" alt="DEMCON" title="DEMCON" />
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.embl.de/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embl.png"
        alt="EMBL"
        title="EMBL" />
      <img v-else src="./img/embl-darkMode.png" alt="EMBL" title="EMBL" />
    </a>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4 id="why">About VIZBI Sponsorship</h4>
  <p>
    VIZBI is an international conference series on Visualizing Biological Data, funded by the NIH
    and EMBO. It alternates annually between the European Molecular Biology Laboratory in
    Heidelberg, Germany, and the Broad Institute of MIT and Harvard in Cambridge MA, USA.
  </p>
  <p>
    VIZBI 2016 offered opportunities to promote organisations engaged with either data
    visualisation or the life sciences. Sponsors gained exposure in a community that includes some
    of the most knowledgeable researchers and professionals working in biological data
    visualisation. Over 130 scientists, software developers, medical professionals, illustrators
    and designers from around the world attended VIZBI 2016, along with a further 30 delegates
    participating via live stream.
  </p>
  <p>
    If you are interested in future sponsorship opportunities, please download the
    <a href="/2016/Sponsorship_form.pdf" target="_blank">VIZBI 2016 Sponsorship form</a>
    or contact us at <Email to="vizbi-contact" />.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.autodesk {
  max-height: calc(3.3rem * 0.6);
}
</style>
